import { render, staticRenderFns } from "./templates-dynamic-checkbox.vue?vue&type=template&id=0252f4ed&scoped=true&lang=pug"
import script from "./templates-dynamic-checkbox.vue?vue&type=script&lang=js"
export * from "./templates-dynamic-checkbox.vue?vue&type=script&lang=js"
import style0 from "./templates-dynamic-checkbox.vue?vue&type=style&index=0&id=0252f4ed&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0252f4ed",
  null
  
)

export default component.exports